import { createGlobalStyle, GlobalStyleComponets } from 'styled-components'

export default createGlobalStyle`
    *, body {
        margin: 0;
        padding: 0;
    }
`